import { fadeIn, scaleUp } from '../../Styles/keyframes'
import { createAnimation, styled } from '../../Styles/stitches.config'
import { StyledInput } from '../Input/styles'
import { StyledLabel } from '../Label/styles'
import { StyledSVG } from '../SVG/styles'

export const StyledIndicator = styled('div', {
    bgc: '$neutral50',
    px: '$2',
    transition: '$default',

    [`& ${StyledSVG}`]: {
        ...createAnimation([fadeIn, scaleUp]),
        color: '$primary600',
        h: 12,
        transition: '$default',
        w: 16,
    },

    variants: {
        autoPointerEvents: {
            true: {
                pointerEvents: 'auto',
            },
        },
        showIndicator: {
            true: {
                [`& ${StyledSVG}`]: {
                    opacity: 1,
                    transform: 'scale(1)',
                },
            },
            false: {
                [`& ${StyledSVG}`]: {
                    opacity: 0,
                    transform: 'scale(0.5)',
                },
            },
        },
    },
})

export const StyledIndicators = styled('div', {
    bgc: '$neutral200',
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'row-reverse',
    gap: 1,
    mx: '-$2',
    pointerEvents: 'none',
    position: 'absolute',
    right: 16,

    variants: {
        disabled: {
            true: {
                [`& ${StyledSVG}`]: {
                    color: '$neutral200',
                },
            },
        },
    },
})

export const StyledOption = styled('span', {
    bgc: '$white',
    color: '$primary600',
    cursor: 'pointer',
    p: '$2 $3',

    '&:hover': {
        bgc: '$neutral50',
    },

    [`& ${StyledSVG}`]: {
        verticalAlign: 'middle',
    },

    variants: {
        isSelectedOption: {
            true: {
                bgc: '$neutral50',
                fontWeight: 600,
            },
        },
        unselect: {
            true: {
                fontStyle: 'italic',
            },
        },
    },
})

export const StyledValue = styled('div', {
    color: '$primary600',
    left: '$3',
    lineHeight: 1.1,
    pointerEvents: 'none',
    position: 'absolute',

    [`& ${StyledSVG}`]: {
        maxH: '100%',
        verticalAlign: 'middle',
    },
})

export const StyledMenu = styled('div', {
    border: '1px solid $primary400',
    boxShadow: '$default',
    br: '$1',
    overflow: 'hidden',
    zIndex: '$tooltip',
})

export const StyledOptions = styled('div', {
    bgc: '$neutral100',
    display: 'grid',
    gap: 1,
    overflow: 'overlay',

    '&::-webkit-scrollbar': {
        w: 14,
    },

    '&::-webkit-scrollbar-track': {
        boxShadow: 'inset 0 0 10px 10px $colors$neutral200',
        border: '4px solid transparent',
        br: '$2',
    },

    '&::-webkit-scrollbar-thumb': {
        boxShadow: 'inset 0 0 10px 10px $colors$neutral500',
        border: '4px solid transparent',
        br: '$2',
    },
})

export const StyledSelect = styled('div', {
    alignItems: 'center',
    display: 'inline-flex',
    justifyContent: 'space-between',
    position: 'relative',

    variants: {
        hasLabel: {
            true: {
                [`& ${StyledValue}`]: {
                    bottom: '$2',
                },

                [`& ${StyledInput}`]: {
                    pb: 'calc($2)',
                    pt: 'calc($3 + $1)',

                    '&:not(:focus)::placeholder': {
                        color: 'transparent',
                    },

                    [`&:focus ~ ${StyledLabel}`]: {
                        transform: 'translate($space$3, $space$1) scale(0.85)',
                    },
                },

                [`& ${StyledLabel}`]: {
                    color: '$neutral400',
                    left: 0,
                    pointerEvents: 'none',
                    position: 'absolute',
                    top: 0,
                    transform:
                        'translate($space$3, calc(($space$3 + $space$2) / 2)) scale(1)',
                    transformOrigin: 'left top',
                    transition: '$default',
                },
            },
        },
        valueSelected: {
            true: {},
        },
    },

    compoundVariants: [
        {
            hasLabel: true,
            valueSelected: true,
            css: {
                [`& ${StyledLabel}`]: {
                    transform: 'translate($space$3, $space$1) scale(0.85)',
                },
            },
        },
    ],
})
